import { D } from '@mobily/ts-belt';
type JsonLdPrimitive = string | number | boolean | null;
type JsonLdValue = JsonLdPrimitive | JsonLdSchema | JsonLdValue[] | null;
export type JsonLdSchema = {
  [key: string]: JsonLdValue;
};

// https://validator.schema.org/
// https://search.google.com/test/rich-results
const organizationJsonLdData: JsonLdSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Stitch Fix',
  url: 'https://www.stitchfix.com/',
  logo: `${process.env.NEXT_PUBLIC_CLOUDFRONT_PATH}/image/upload/v1680644457/landing-pages/logo.png`,
  sameAs: ['https://www.facebook.com/stitchfix', 'https://www.instagram.com/stitchfix/', 'https://en.wikipedia.org/wiki/Stitch_Fix', 'https://twitter.com/stitchfix', 'https://www.pinterest.com/stitchfix/']
};

// Safe for `dangerouslySetInnerHTML` inside `<script type="application/ld+json">`: raw `<` allows `</script>` break-out / XSS
export const safeSerializeJsonLdForScript = (schema: unknown): string => {
  return JSON.stringify(schema).replace(/</g, '\\u003c');
};

// JSON-LD (JavaScript Object Notation for Linked Data) is used to improve SEO (Search Engine Optimization)
// by informing search engines how to attribute website data with the content
// and brand to display information in a consistent and structured way.
// https://developers.google.com/search/docs/appearance/structured-data/intro-structured-data
export const JsonLd = ({
  data
}: {
  data?: JsonLdSchema | JsonLdSchema[] | null;
}) => {
  let pageData: JsonLdSchema[] = [];
  if (data && D.isNotEmpty(data)) {
    pageData = Array.isArray(data) ? data : [data];
  }
  const schemas = [organizationJsonLdData, ...pageData];
  return <>
      {schemas.map((schema, index) => <script
    // eslint-disable-next-line react/no-array-index-key
    key={`app-ld-json-${index}`} id={`app-ld-json-${index}`} type="application/ld+json" dangerouslySetInnerHTML={{
      __html: safeSerializeJsonLdForScript(schema)
    }} />)}
    </>;
};